// extracted by mini-css-extract-plugin
module.exports = {"controls":"style__controls___2yR4Y","button":"style__button___24NhC"};